<div
    class="banner-message d-flex w-100 mb-3 position-relative"
    [ngClass]="{ 'd-none': !displayMaxItemsAlert, 'mb-3': !customClass }"
>
    <div class="banner-border {{ type }} position-absolute"></div>
    <div
        class="p-3 pe-5 position-relative w-100 d-flex flex-row align-items-center"
        [ngClass]="customClass ? 'primmary-color' : 'default-color'"
    >
        @if (displayCloseButton) {
            <button
                mat-icon-button
                aria-label="Close banner"
                class="position-absolute end-0 top-0"
                type="button"
                (click)="closeBanner()"
            >
                <mat-icon>close</mat-icon>
            </button>
        }
        @if (showIconType) {
            <mat-icon class="icon icon-{{ type }} me-2 md-icon-24"> info </mat-icon>
        }
        <div class="d-flex flex-column">
            @if (bannerTitle) {
                <div class="mb-1 mat-headline-6">{{ bannerTitle }}</div>
            }
            <div [innerHtml]="bannerMessage" class="mat-body-1 text mb-0"></div>
        </div>
    </div>
</div>
